import { createReducer, on } from '@ngrx/store';
import { Local, LocalForm } from '@core/models';
import {
  STORE_FIND_SUCCESS,
  STORE_FAILURE,
  STORE_UPDATE_FORM,
  STORE_RESET_ERROR,
  STORE_RESET,
  STORE_RESET_FORM,
  STORE_FIND_ALL_SUCCESS,
  STORE_EDIT_MODE,
  STORE_CLEAR_STATE,
  STORE_UPDATE_LOADING,
  STORE_UPDATE_ID,
  STORE_FIND_ALL_DROPDOWNS_SUCCESS
} from '@store/actions';
import { ResponseBadRequest } from '@core/interfaces/response-bad-request';
import { transformArrayStoreData, transformStoreData } from '@core/helpers';

export interface StoreState {
  loading: boolean;
  storeList: Local[] | null;
  error: ResponseBadRequest | null;
  editMode: boolean;
  isEditing: boolean;
  storeForm: LocalForm | null;
  storeId: string | null;
  store: Local | null;
  storeListDropdowns: Local[] | null;
}

export const initialState: StoreState = {
  loading: false,
  storeList: null,
  error: null,
  editMode: false,
  isEditing: false,
  storeForm: null,
  storeId: null,
  store: null,
  storeListDropdowns: null,
};

export const storeReducer = createReducer(
  initialState,
  on(STORE_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(STORE_FIND_SUCCESS, (state, { store }) => ({ ...state, store: transformStoreData(store) })),
  on(STORE_FIND_ALL_SUCCESS, (state, { storeList }) => ({ ...state, storeList: transformArrayStoreData(storeList) })),
  on(STORE_FAILURE, (state, { error }) => ({ ...state, error })),
  on(STORE_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(STORE_UPDATE_FORM, (state, { storeForm }) => ({ ...state, storeForm: { ...state.storeForm, ...storeForm } })),
  on(STORE_UPDATE_ID, (state, { storeId }) => ({ ...state, storeId })),
  on(STORE_RESET, (state) => ({ ...state, store: null, storeId: null, storeForm: null })),
  on(STORE_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(STORE_RESET_FORM, (state) => ({ ...state, storeForm: null, loading: false })),
  on(STORE_CLEAR_STATE, (state) => ({ ...initialState, loading: state.loading })),
  on(STORE_FIND_ALL_DROPDOWNS_SUCCESS, (state, { storeListDropdowns }) => ({ ...state, storeListDropdowns: transformArrayStoreData(storeListDropdowns) })),
);
